// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .skeletonStyle {
    margin-top: 40px;
    height: 150px;
  }

  .tooltip-cont {
    display: flex;
    width: 150px;
    justify-content: flex-end;
  }
  div .tooltip-bubble {
    bottom: 94%;
    left: 31px;
    min-width: 248px;
  }
  div.input-radio-title {
    font-size: 14px;
    font-weight: 500;
    margin-left: 10px;
  }
  div.radio-button-checked + .input-radio-title {
    font-weight: 500;
  }
  .order-filter-cont {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;
    margin-top: 10px;
  }
  .order-filter-cta {
    width: auto;
    height: 40px;
    border-radius: 5px;
    border: 1px solid ${(props) => props.theme.colorPalette.gray[600]};
    background-color: white;
    align-items: center;
    display: flex;
    text-transform: capitalize;
    position: relative;
  }
  .radio-group {
    display: flex;
    align-items: center;
    padding: 10px 0px 10px 0px;
  }

  .order-filters-radio {
    padding-bottom: 10px;
    display: flex;
    align-items: center;
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    div.TCPModal__InnerContent.editModal-innerContent .modal-heading:before {
      background-color: #d9d9d9;
      bottom: 12px;
    }
    div.TCPModal__InnerContent.editModal-innerContent {
      max-height: 420px;
    }
    .order-filters-radio {
      height: 43px;
    }
    .modal-container {
      position: relative;
      height: 100%;
    }
    .empty-order-cont {
      text-align: center;
    }
    .empty-text-cont {
      text-align: center;
    }
  }

  ${(props) =>
    props.showOrderListWithItemDetails &&
    !(props.orderHistoryExtendedEnabled && props.filterModalState)
      ? `background-color: ${props.theme.colorPalette.gray['300']};
      ${`@media ${props.theme.mediaQuery.smallOnly} {
        margin-left: -14px;
        margin-right: -14px;
       
      }`}
      @media ${props.theme.mediaQuery.mediumOnly} {
        margin: -${props.theme.spacing.ELEM_SPACING.XL} -15px 0;
        padding: ${props.theme.spacing.ELEM_SPACING.XL} 15px 0;
      }
      @media ${props.theme.mediaQuery.large} {
        background-color: ${props.theme.colors.WHITE};
      }`
      : ''}

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .back-link {
      background-color: white;
      margin: -14px -14px 4px -14px;
      padding: 10px;
    }
  }
  .load-more {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: ${(props) => props.theme.colorPalette.gray[3400]};
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    -webkit-tap-highlight-color: transparent;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
    }
    .load-more-cta {
      width: 200px;
    }
  }
  .account-goback-link {
    display: none;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: block;
      background-color: white !important;
      margin: -14px -14px 4px -14px !important;
      padding: 10px !important;
    }
  }
  .load-more-cta:focus {
    background-color: ${(props) => props.theme.colors.WHITE};
    outline: none;
  }
  .load-more-cta:hover {
    border: solid 1px ${(props) => props.theme.colors.TEXT.GRAY};
    background-color: ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
  }
  ${(props) => (props.showOrderListWithItemDetails ? 'min-height:600px;' : '')}
  .page-heading {
    text-transform: uppercase;
    background-color: ${(props) => props.theme.colors.WHITE};
  }
  .bottom-section-container {
    color: ${(props) => props.theme.colorPalette.gray[3400]};
  }

  .orders-tile-heading-text {
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs20};
    text-transform: uppercase;
    color: ${(props) => props.theme.colorPalette.gray[900]};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-weight: 700;
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    }
  }
  .orders-tile-heading {
    background-color: ${(props) =>
      props.isBIAEnabledForOrderHistory && props.isBIAAvailProduct
        ? props.theme.colors.WHITE
        : props.theme.colorPalette.gray[3400]};
    align-items: center;
    display: flex;
    margin-left: -53px;
    margin-top: -14px;
    margin-right: -56px;
    padding-left: 53px;
    padding-top: 14px;
    margin-bottom: -20px;
    padding-bottom: 12px;
    .orders-tile-heading-left {
      display: flex;
      align-items: center;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      justify-content: space-between;
      margin-right: -9px;
    }
  }

  .new-page-heading {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    text-transform: uppercase;
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
    background-color: ${(props) => props.theme.colorPalette.gray[3400]};
    padding: 12px 0px;
    border-bottom: 0px;
    margin-bottom: 0px;
  }
  .empty-orders-list-wrapper {
    ${(props) => (props.orderHistoryExtendedEnabled ? `padding-top: 10px;` : `padding-top: 30px;`)}

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.orderHistoryExtendedEnabled ? `padding-top: 10px;` : `padding-top: 100px;`}
    }
  }
  position: relative;
`;

export default styles;
